export enum ERROR_CODES {
  PAYMENT_INVALID_ABA_FILE = "PAYMENT_INVALID_ABA_FILE",
  PAYMENT_DUPLICATE_ABA_FILE = "PAYMENT_DUPLICATE_ABA_FILE",
  PAYMENT_FAILED_PROCESSING_ABA = "PAYMENT_FAILED_PROCESSING_ABA",
}
